import { boot } from 'quasar/wrappers';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser'; // Importação adicionada
import { Platform } from 'quasar';

export default boot(({ router }) => {
  if (Platform.is.capacitor && window.self === window.top) {
    App.addListener('appUrlOpen', async (event) => {
      console.log('Capacitor: appUrlOpen disparado!', event);

      if (event.url.includes('/media_public/qrcode/')) {
        await Browser.open({ url: event.url });
        return; // Impede que o restante do código execute
      }

      try {
        const urlObj = new URL(event.url);

        // IMPORTANTE: Pegamos pathname + search (query params) + hash
        // Se o seu app usa modo 'hash' (ex: #/minha-rota), a lógica muda um pouco,
        // mas para History mode (padrão do Quasar mobile), isso é o correto.
        const fullPath = urlObj.pathname + urlObj.search + urlObj.hash;

        // Opção A: Redirecionamento nativo (Hard Reload)
        // Isso recarrega a aplicação do zero na nova rota.
        // O 'beforeEnter' e 'created' rodarão novamente garantido.
        if (fullPath) {
          window.location.href = fullPath;
        }

      } catch (e) {
        console.error('Erro ao processar Deep Link', e);
      }
    });
  }
});